export default __webpack_public_path__ + "static/media/Dopagut-10-ban.a5473bbd.jpg";